import React, { useMemo } from "react";
import Container from "../../../../CommonElements/Container";
import { useCompetition } from "../../../../context/CompetitionContext";
import { useLanguage } from "../../../../context/LanguageContext";
import { interpolate } from "../../../../i18n/translate";
import useReveal from "../../../../hooks/useReveal";

const Rules = () => {
  const { t } = useLanguage();
  const { competition } = useCompetition();
  const [revealRef, inView] = useReveal();

  const balance = competition.startingBalance || competition.stats?.[1]?.value || "";
  const prizePool = competition.totalPrizePool || "";

  const rules = useMemo(() => {
    const raw = Array.isArray(t("rules.items")) ? t("rules.items") : [];
    return raw.map((rule) => ({
      ...rule,
      description: interpolate(rule.description || "", { balance, prizePool }),
    }));
  }, [t, balance, prizePool]);

  return (
    <section className={`section rules${inView ? " is-in" : ""}`} id="rules" ref={revealRef}>
      <Container>
        <h2 className="rules__title">{t("rules.title")}</h2>

        <div className="rules__grid">
          {rules.map((rule, index) => (
            <article className="card card--rule" key={index}>
              <span className="card__badge">{String(index + 1).padStart(2, "0")}</span>
              <h3 className="card__title">{rule.title}</h3>
              <p className="card__text">{rule.description}</p>
            </article>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Rules;
